import React from 'react';

const Tabs = ({ activeTab, onChange, children }) => {
  return (
    <div>
      <ul className="tabs">
        {children.map((tab, index) => (
          <li
            key={index}
            className={index === activeTab ? 'active' : ''}
            onClick={() => onChange(index)}
          >
            {tab.props.label}
          </li>
        ))}
      </ul>
      <div className="tab-content">
        {children[activeTab]}
      </div>
    </div>
  );
};

const Tab = ({ children }) => {
  return <>{children}</>;
};

export { Tabs, Tab };